import React, {useEffect, useState, useContext} from 'react';
import styled, {ThemeContext} from 'styled-components';

import { Context } from '../Context/ThemeContext';
import { toast } from 'react-toastify';

import api from '../api';
import useAuth from '../Context/hooks/useAuth';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import CardPessoa from '../components/CardPessoa';
import Card from '../components/Card';
import DescricaoPagina from '../components/DescricaoPagina';

// const imgSprite = 'human';
// const imgSprite = 'bottts';
// const imgSprite = 'initials';
const imgSprite = 'avataaars';

const Usuarios = () => {
    const [usuarios, setUsuarios] = useState([]);
    const [erroRequest, setErroRequest] = useState();
    
    useEffect( () => {
        (async () => {
                const { data } = await api.get('usuarios');
                setUsuarios(data);
            }
        )()
    },[]);

    const buscarUsuarios = () => {
		api.get('usuarios')
			.then(res => {
                setUsuarios(res.data)
			})
	}

   const handleSubmit = event => {
		event.preventDefault();

		const formData = new FormData(event.target);

		// var object = {};
		// formData.forEach((value, key) => {
		// 	// Reflect.has in favor of: object.hasOwnProperty(key)
		// 	if (!Reflect.has(object, key)) {
		// 		object[key] = value;
		// 		return;
		// 	}
		// 	if (!Array.isArray(object[key])) {
		// 		object[key] = [object[key]];
		// 	}
		// 	object[key].push(value);
		// });

        // setErroRequest('');

		api.post('usuarios', formData)
			.then(res => {
                toast.success(<h6>Usuario cadastrado</h6>)
				buscarUsuarios();
			})
			.catch((error) => {
                let msg = '';
                // Error
                if (error.response) {
                    msg = error.response.data;
                }

                else if (error.request) {
                    msg = error.request;
                }
                
                else {
                    msg = error.message;
                }

                setErroRequest(msg);

			});

	}

    return(
        <>
            <DescricaoPagina titulo="Usuarios" />
            <div className="container">
           
                <div className="col-12 p-0">
                    <Card
                        titulo="Cadastrar Usuário"
                    >

                        <form onSubmit={handleSubmit} style={{margin: '1rem'}}>

                            <div>
                                <TextField size="small" label="Nome"  name="nome" variant="outlined" />
                            </div>

                            <div style={{marginTop: '1rem'}}>
                                <TextField size="small" label="Email"  name="email" variant="outlined" />
                            </div>


                            <div style={{marginTop: '1rem'}}>
                                <TextField  type={'password'} size="small" label="Senha"  name="password" variant="outlined" />
                            </div>

                            <div style={{marginTop: '1rem'}}>
                                <TextField type={'password'} size="small" label="Confirmar Senha"  name="confirmPassword" variant="outlined" />
                            </div>
                        
                            <div style={{marginTop: '1rem'}}>
                                {erroRequest && <p style={{color: 'red'}}>{erroRequest}</p>}
                            </div>

                            <div style={{marginTop: '1rem'}}>
                                <Button type="submit" variant="contained" color="primary">Salvar</Button>
                            </div>

                        </form>
                    </Card>
                </div>

                { usuarios && usuarios.map(usuario => {
                    return(
                        <CardPessoa key={usuario.id} nome={usuario.nome} email={usuario.email} img={`https://avatars.dicebear.com/4.5/api/${imgSprite}/${usuario.nome}.svg`}> </CardPessoa>
                    )
                })}

                

            </div>

        </>
    )

}


export default Usuarios;